import { prop } from 'ramda';
import withAxios from '../utils/with-axios.js';
import { urls } from '../config.js';

/**
 * Fetches brand assets (logo and gift card images) for a Tillo brand
 *
 * @param {axios} api
 * @param {string} tilloBrand The Tillo brand identifier
 * @returns {Promise<{logoUrl: string, giftCardUrl: string}>}
 */
var getBrandAssets = function getBrandAssets(api, tilloBrand) {
  return api.get(urls.apiV3("/brand-assets/".concat(tilloBrand))).then(prop('data'));
};
export default {
  getBrandAssets: withAxios(getBrandAssets)
};